/**
 * Created by JIocb on 20.06.2017.
 */
module Arkadium.Core.utils {

    import Signal = Factive.Core.Signal.Signal;
    export class LocalizationManager {

        private _textByKey = [];
        private _locale: string;
        public signal: Signal;

        constructor()
        {
            this.signal = new Signal();
		}

        public initialize(cdnUrl: string, locale: string = "en-US"): void {
            this._locale = locale;
            var path: string = cdnUrl + "build/resources/assets/texts/"+locale+".txt";
            PIXI.loader.add(locale, path)
            PIXI.loader.once("complete", this.handleLoadingComplete, this);

        };

        private handleLoadingComplete(loader, resources) {

            if (resources[this._locale]) {
                var str: string = resources[this._locale].data;
                this.parseTexts(str);
                this.signal.dispatch("complete");
            }
        }

        public getText(key: string): string {
            return (this._textByKey[key] || key);
        }

        private parseTexts(str: string) {


            var key, value, textLine, separatorIndex;
            var textData = str.split('\n');
            for (var i = 0; i < textData.length; ++i) {
                textLine = textData[i].trim();
                if (textLine.indexOf(';') !== 0) { // skip comment line
                    separatorIndex = textLine.indexOf('=');
                    if (separatorIndex === 0) {
                        console.error('LocalizationManager.setLocale: no key, invalid localized text line <' + textLine + '>');
                        continue;
                    }
                    if (separatorIndex !== -1) {
                        key = textLine.substr(0, separatorIndex).trim();
                        if (separatorIndex - 1 < textLine.length) {
                            value = textLine.substr(separatorIndex + 1, textLine.length - separatorIndex).trim();
                        } else {
                            value = ''; // empty line. It is weird, but valid.
                            //$debug
                            //console.log('LocalizationManager.setLocale: empty value, possibly invalid localized text line <' + textLine + '>');
                        }
                        this._textByKey[key] = value;
                        //$debug
                    } else {
                        //$debug
                        //console.log('LocalizationManager.setLocale: empty line');
                    }
                }
            }

        }

        public destroy():void
        {
            this.signal.removeAll();
            this.signal = null;

            this._textByKey = null;
        }
    }


}


// WEBPACK FOOTER //
// src/typescript/Core/Utils/LocalizationManager.ts